import * as React from "react";

import { IPageContainerProps } from "@montana/containers/page";
import { Container } from "@montana/shared/container";
import { DynamicBlocks } from "@montana/blocks/dynamic-blocks.component";

export const FrontPage: React.FC<IPageContainerProps> = React.memo((props: IPageContainerProps): JSX.Element => {
    const { blocks } = props;
    
    return (
        <Container className="pb-10 lg:pb-20">
            <DynamicBlocks blocks={blocks} />
        </Container>
    );
});
